import { useI18n } from '@/i18n';
import { Check } from 'lucide-react';

export function PriceSection({ property }) {
  const { formatPrice, t } = useI18n();

  return (
    <div className="mb-6" data-testid="price-section">
      {property.price_min_usd ? (
        <>
          {property.price_max_usd && property.price_max_usd > property.price_min_usd && (
            <div className="mb-1">
              <span className="text-lg text-[#78716C] line-through">
                {formatPrice(property.price_max_usd)}
              </span>
              <span className="ml-2 text-xs bg-[#ECFCCB] text-[#3F6212] px-2 py-0.5 rounded-full font-medium">
                -{Math.round((1 - property.price_min_usd / property.price_max_usd) * 100)}% OFF
              </span>
            </div>
          )}
          <span className="text-3xl font-bold text-[#1C1917]" style={{ fontFamily: 'Outfit' }}>
            {formatPrice(property.price_min_usd)}
          </span>
          <span className="text-[#57534E]"> {t('common.perNight')}</span>
        </>
      ) : (
        <span className="text-xl font-semibold text-[#1C1917]">
          {t('detail.selectDates')}
        </span>
      )}
    </div>
  );
}

export function DiscountBadges({ property }) {
  if (!property.weekly_discount && !property.monthly_discount) return null;

  return (
    <div className="mb-6 space-y-2">
      {property.weekly_discount && (
        <div className="flex items-center text-sm text-[#3F6212] bg-[#ECFCCB] px-3 py-2 rounded-lg">
          <Check className="w-4 h-4 mr-2" />
          {property.weekly_discount * 100}% descuento semanal
        </div>
      )}
      {property.monthly_discount && (
        <div className="flex items-center text-sm text-[#3F6212] bg-[#ECFCCB] px-3 py-2 rounded-lg">
          <Check className="w-4 h-4 mr-2" />
          {property.monthly_discount * 100}% descuento mensual
        </div>
      )}
    </div>
  );
}
